import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

export default function AdminDashboard() {
  const [passcode, setPasscode] = React.useState("");
  const [authed, setAuthed] = React.useState(false);
  const [error, setError] = React.useState("");
  const [checking, setChecking] = React.useState(false);

  const handleAuth = async (e) => {
    e.preventDefault();
    if (!passcode) return;
    setChecking(true);
    setError("");
    try {
      const { api } = await import("../../lib/api");
      await api.get("/admin/auth", { params: { passcode } });
      setAuthed(true);
    } catch (_) {
      setAuthed(false);
      setError("Incorrect passcode.");
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="mx-auto max-w-4xl px-4 py-6 sm:py-10 space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="text-slate-900 dark:text-slate-100">Admin Dashboard</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {!authed ? (
            <form onSubmit={handleAuth} className="flex items-end gap-3">
              <div className="flex-1">
                <label htmlFor="passcode" className="block text-sm font-medium mb-1">Enter Passcode</label>
                <input
                  id="passcode"
                  type="password"
                  value={passcode}
                  onChange={(e) => setPasscode(e.target.value)}
                  className="w-full rounded-md border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400"
                  placeholder="Admin passcode"
                  required
                  data-testid="admin-dashboard-passcode-input"
                />
              </div>
              <Button type="submit" data-testid="admin-dashboard-unlock-button" disabled={checking}>{checking ? "Checking..." : "Unlock"}</Button>
            </form>
          ) : (
            <div className="space-y-3">
              <div className="text-sm text-slate-500">You are viewing admin links. Passcode will be appended to queries.</div>
              <div className="flex flex-col gap-2">
                <a className="text-blue-600 hover:underline" href={`/admin/contact?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-contact-link">Contact Requests</a>
                <a className="text-blue-600 hover:underline" href={`/admin/referrals?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-referrals-link">Referral Analytics (Search + Date Filters)</a>
                <a className="text-blue-600 hover:underline" href={`/admin/counters?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-counters-link">Visitor & Weekly Counters</a>
                <a className="text-blue-600 hover:underline" href={`/admin/ads?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-ads-link">Ad Rotation Manager</a>
                <a className="text-blue-600 hover:underline" href={`/admin/forum?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-forum-link">Forum Moderation & Users</a>
                <a className="text-blue-600 hover:underline" href={`/admin/guide?passcode=${encodeURIComponent(passcode)}`} data-testid="admin-dashboard-guide-link">Guide Weekly Text Editor</a>

              </div>
            </div>
          )}
          {!!error && <div className="text-sm text-red-600" data-testid="admin-dashboard-passcode-error">{error}</div>}
        </CardContent>
      </Card>
    </div>
  );
}
